import { Tooltip } from '@material-ui/core';
import React from 'react';

import { Div, Text, usePublicaTranslation } from '~/src/dash/publicaUI';
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const BetaTooltipIcon = () => {
  const { t } = usePublicaTranslation();
  return (
    <Tooltip title={t('TooltipBeta')}>
      <div>
        <Div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2px 6px',
            backgroundColor: getColorTheme('betaIconBackground'),
            boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)',
            borderRadius: '3px',
          }}
        >
          <Text
            bold
            mini
            color={getColorTheme('betaIconText')}
            style={{
              fontWeight: 500,
              fontSize: '12px',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
            }}
          >
            {t('Beta')}
          </Text>
        </Div>
      </div>
    </Tooltip>
  );
};
